"use strict";

var Backbone = require('backbone');

var TravelModel = Backbone.Model.extend({
  /*
   * Holds the travel information, excluding eta.
   */

  defaults: {
    transport_type: 'plane'
  },

  shouldCalculateJourney: function() {
    /*
     * Has the user selected transport options that allow
     * us to query the platform to get an estimated
     * arrival time?
     */
    var transport_type = this.get('transport_type');

    if (transport_type) {
      if (transport_type === 'plane') {
        return true;
      }
      if (transport_type === 'train' && this.get('train_station') !== 'N/A') {
        return true;
      }
    }
    return false;
  },

  canCalculateJourney: function() {
    /*
     * Similar to `shouldCalculateJourney`. The difference
     * is that it tells us if we have enough data to
     * actually query the platform for the journey plan.
     */
    var transport_type = this.get('transport_type');

    if (transport_type && this.get('transfer_type')) {
      if (transport_type === 'plane') {
        if (this.get('flight_number')) return true;
        if (this.get('airport') && this.get('flight_eta')) return true;
      }
      if ((transport_type === 'train') && this.get('train_station') !== 'N/A' && this.get('train_eta')) {
        return true;
      }
    }
    return false;
  },

  hub: function() {
    if (this.get("transport_type") == "plane") {
      return this.get("airport");
    } else if (this.get("transport_type") == "train") {
      return this.get("train_station");
    }
  },

  transferAmount: function() {
    return this.get("bookable_transfers")[this.hub()];
  },

  hasTransferAmount: function() {
    var privateCar = this.get("transfer_type") === "private";

    if (!privateCar) return false;

    var transferAmount = this.transferAmount();

    return !_.isUndefined(transferAmount);
  },

  canOrganiseTransfer: function() {
    return this.hasTransferAmount() && this.get("num_guests") <= 4;
  },

  validate: function() {
    var transport_type = this.get('transport_type');

    if (transport_type) {
      if (transport_type === 'plane') {
        if (this.get('flight_number') && this.get('transfer_type')) return;
        if (this.get('airport') && this.get('flight_eta') && this.get('transfer_type')) return;
      } else if (transport_type === 'train') {
        var transferType = this.get('transfer_type');
        var station = this.get('train_station');

        if (station) {
          if (station !== 'N/A' && transferType) {
            if (this.get('train_eta')) return;
          }
          if (this.get('other_station')) return;
        }
      } else if (transport_type === 'car') {
          return;
      } else if (transport_type === 'other') {
        if (this.get('other_method')) return;
      }
    }
    return 'invalid';
  }
});

module.exports = TravelModel;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/arrival/models/travelmodel.js
 **/